import React, { useEffect, useState } from "react";
import TaskPopUp from "../components/Popup/TaskPopUp";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const TaskPage = () => {
  const { taskId } = useParams();
  const [taskData, setTaskData] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const ids = location.state?.ids || [];

  const gettaskData = async () => {
    const userToken = localStorage.getItem("user-token");

    const headers = {
      authorization: userToken,
    };

    const bUrl = `/task/${taskId}`;

    try {
      const response = await axios.get(bUrl, { headers });
      setTaskData(response.data.data);
      setMessage(null); // reset message when navigating to a new task
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    gettaskData();
    console.log("ids", ids);
  }, [taskId]);

  const goBack = () => {
    if (location.state?.from) {
      console.log("goBack from");
      navigate(location.state.from);
    } else {
      console.log("goBack history");
      if (window.history.length > 2) {
        navigate(-1);
      } else {
        navigate("/tasksList/all");
      }
    }
  };

  const goToNextTask = () => {
    const index = ids.indexOf(taskId);
    const nextId = ids[index + 1];

    console.debug(ids, index, nextId, location.state.from, "next task");

    if (nextId) {
      navigate(`/task/${nextId}`, {
        state: { ids, from: location.state.from },
      });
    } else {
      toast.success("✅ All tasks done on this page.");
      setMessage("✅ All tasks done on this page.");
    }
  };

  const goToPreviousTask = () => {
    const index = ids.indexOf(taskId);
    const prevId = ids[index - 1];

    console.debug(ids, index, prevId, location.state.from, "previuous task");

    if (prevId) {
      navigate(`/task/${prevId}`, {
        state: { ids, from: location.state.from },
      });
    } else {
      toast.error("⏮️ This is the first task.");
      setMessage("⏮️ This is the first task.");
    }
  };

  if (!taskData) {
    return "Loading....";
  }

  return (
    <div className="ml-20">
      <TaskPopUp
        className=""
        taskData={taskData}
        getTaskData={gettaskData}
        onClose={goBack}
        share={false}
        goToPreviousTask={goToPreviousTask}
        goToNextTask={goToNextTask}
      />
    </div>
  );
};

export default TaskPage;
